import { AppRole } from "../../../@api";

export const allFeatureRoles = [
  AppRole.ChatbotFeature,
  AppRole.ImageGenerationFeature,
  AppRole.TranscriptionFeature,
  AppRole.SummarizationFeature,
  AppRole.TranslationFeature,
  AppRole.SchornBoxFeature,
];
